import Axios from 'axios';
import {urlAPIDirectus} from "../config/Globals";

function findAll(){
    return Axios
        .get(urlAPIDirectus+"PilierLutte?filter[status][_eq]=published")
        .then(response => response.data.data);
}
function find(wording){
    return Axios
        .get(urlAPIDirectus+"PilierLutte?filter[status][_eq]=published&filter[wording][_eq]="+wording)
        .then(response => response.data.data[0]);
}

export default {
    findAll, find
}